import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

interface AdminActionButtonProps {
  icon: IconDefinition;
  onClick: () => void;
  title?: string;
  hoverColor?: string;
  disabled?: boolean;
  spinning?: boolean;
  className?: string;
}

const AdminActionButton: React.FC<AdminActionButtonProps> = ({
  icon,
  onClick,
  title,
  hoverColor = 'hover:text-blue-600',
  disabled = false,
  spinning = false,
  className = '',
}) => {
  return (
    <button
      onClick={(e) => { e.stopPropagation(); onClick(); }}
      disabled={disabled}
      title={title}
      className={`text-gray-600 ${hoverColor} cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed transition-colors ${spinning ? 'animate-spin' : ''} ${className}`}
    >
      <FontAwesomeIcon icon={icon} />
    </button>
  );
};

export default AdminActionButton;
